import actions from './stockcompare-dashboard.actions'
import getters from './stockcompare-dashboard.getters'
import mutations from './stockcompare-dashboard.mutations'
import state from './stockcompare-dashboard.state'

export default {
  namespaced: true,
  state: state(),
  getters,
  mutations,
  actions
}
